import { createContext, useContext, useEffect, useState } from 'react';
import { DICCIONARIO_COMPONENTS_BY_PATH } from './normalizer';
import { sessionStorageKey_menuRoutes, sessionStorageKey_session } from './constants';

// Create the context
export const GlobalContext = createContext();

const initialMenuRoutes = () => {
  const savedValue = sessionStorage.getItem(sessionStorageKey_menuRoutes);
  if (savedValue) {
    const parseToJson = JSON.parse(savedValue);
    const formatJson = {
      ...parseToJson,
      paths: parseToJson.paths.map((path) => ({
        path: path.path,
        element: DICCIONARIO_COMPONENTS_BY_PATH[path.path]
      }))
    };
    return formatJson;
  } else {
    return { paths: [], menuData: [] };
  }
};
const initialUserSession = () => {
  const savedValue = sessionStorage.getItem(sessionStorageKey_session);
  if (savedValue) {
    return JSON.parse(savedValue);
  } else {
    return null;
  }
};

export const GlobalProvider = ({ children }) => {
  const [user, setUser] = useState(initialUserSession());
  const [menuRoutes, setMenuRoutes] = useState(initialMenuRoutes());
  const [menuKeys, setMenuKeys] = useState([]);
  const [isOpenStorageDrawer, setIsOpenStorageDrawer] = useState(false);

  const openStorageDrawer = () => setIsOpenStorageDrawer(true);
  const closeStorageDrawer = () => setIsOpenStorageDrawer(false);

  // Keep menu to show even refresh
  useEffect(() => {
    sessionStorage.setItem(sessionStorageKey_menuRoutes, JSON.stringify(menuRoutes));
  }, [menuRoutes]);


  return (
    <GlobalContext.Provider
      value={{
        user,
        setUser,
        menuRoutes,
        setMenuRoutes,
        menuKeys,
        setMenuKeys,
        isOpenStorageDrawer,
        openStorageDrawer,
        closeStorageDrawer
      }}>
      {children}
    </GlobalContext.Provider>
  );
};

export const useGlobalContext = () => {
  return useContext(GlobalContext);
};
